import { useRouter, useSearch } from "@tanstack/react-router";
import { PartyConfetti } from "@repo/icons";
import { trackEvent } from "@/lib/tracking";
import {
  MessageDrawerRoot,
  MessageDrawerTitle,
  MessageDrawerBody,
  MessageDrawerActions,
  MessageDrawerActionButton,
} from "@/components/message-drawer";

export const AssistProAcceptanceSuccessDrawer = (): JSX.Element => {
  const router = useRouter();
  const { action } = useSearch({
    from: "/settings/assist/assist-pro-acceptance/",
  });

  const handleClose = (open: boolean): void => {
    if (!open) {
      void router.navigate({
        search: {},
        replace: true,
      });
    }
  };

  const handleViewPlan = (): void => {
    trackEvent("Botão Ver Dados Plano Assist Pro Clicado");
    void router.navigate({
      to: "/settings/assist/subscribed-assist",
    });
  };

  return (
    <MessageDrawerRoot
      icon={PartyConfetti}
      open={action === "show-success-assist-pro-drawer"}
      setOpen={handleClose}
      variant="secondary"
      dismissible={false}
    >
      <MessageDrawerTitle>Parabéns, você permanecerá no Assist Pro</MessageDrawerTitle>
      <MessageDrawerBody>
        <span> </span>
      </MessageDrawerBody>
      <MessageDrawerActions>
        <MessageDrawerActionButton onClick={handleViewPlan}>
          Ver meus dados do plano
        </MessageDrawerActionButton>
      </MessageDrawerActions>
    </MessageDrawerRoot>
  );
};
